import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  current: {},
  list: [],
  tentative: {},
}

const employmentsSlice = createSlice({
  name: 'employments',
  initialState,
  reducers: {
    setEmploymentsList: (state, { payload }) => ({ ...state, list: [...payload.employments] }),
    setCurrentEmployment: (state, { payload }) => ({ ...state, current: { ...payload.employment } }),
    setTentativeEmployment: (state, { payload }) => ({ ...state, tentative: { ...payload.employment } }),
    resetEmploymentsState: () => ({ list: [], current: { }, tentative: { } })
  }
});

export const { setEmploymentsList, setCurrentEmployment, setTentativeEmployment, resetEmploymentsState } = employmentsSlice.actions;
export default employmentsSlice.reducer;
